import { getAccessToken } from './getAccessToken';
// @ts-ignore
import moment from 'moment';

// const environmentUrl = "https://org487f0635.crm8.dynamics.com";dev
const environmentUrl = "https://orgea61b289.crm8.dynamics.com";

// Interface for Process Parameter Verification data
export interface ProcessParameterVerificationData {
  cr3ea_productname: string;
  cr3ea_cycle: string;
  cr3ea_rposolidfat_standard?: string | null;
  cr3ea_rposolidfat_temperature?: string | null;
  cr3ea_rposolidfat_action?: string | null;
  cr3ea_invertsyrup_standard?: string | null;
  cr3ea_invertsyrup_temperature?: string | null;
  cr3ea_invertsyrup_action?: string | null;
  cr3ea_butter_standard?: string | null;
  cr3ea_butter_temperature?: string | null;
  cr3ea_butter_action?: string | null;
  cr3ea_blackjack_standard?: string | null;
  cr3ea_blackjack_temperature?: string | null;
  cr3ea_blackjack_action?: string | null;
  cr3ea_water_standard?: string | null;
  cr3ea_water_temperature?: string | null;
  cr3ea_water_action?: string | null;
  cr3ea_creamingtime_standard?: string | null;
  cr3ea_creamingtime_temperature?: string | null;
  cr3ea_creamingtime_action?: string | null;
  cr3ea_mixingtime_standard?: string | null;
  cr3ea_mixingtime_temperature?: string | null;
  cr3ea_mixingtime_action?: string | null;
  cr3ea_doughtemperature_standard?: string | null;
  cr3ea_doughtemperature_temperature?: string | null;
  cr3ea_doughtemperature_action?: string | null;
  cr3ea_standingtime_standard?: string | null;
  cr3ea_standingtime_temperature?: string | null;
  cr3ea_standingtime_action?: string | null;
  cr3ea_biscuitappearance_standard?: string | null;
  cr3ea_biscuitappearance_temperature?: string | null;
  cr3ea_biscuitappearance_action?: string | null;
  cr3ea_stackheightspecifiednobiscuits_standard?: string | null;
  cr3ea_stackheightspecifiednobiscuits_temperature?: string | null;
  cr3ea_stackheightspecifiednobiscuits_action?: string | null;
  cr3ea_dimensionsatpackingtable_standard?: string | null;
  cr3ea_dimensionsatpackingtable_temperature?: string | null;
  cr3ea_dimensionsatpackingtable_action?: string | null;
  cr3ea_moisturecontent_standard?: string | null;
  cr3ea_moisturecontent_temperature?: string | null;
  cr3ea_moisturecontent_action?: string | null;
  cr3ea_drybiscuitweight_standard?: string | null;
  cr3ea_drybiscuitweight_temperature?: string | null;
  cr3ea_drybiscuitweight_action?: string | null;
  cr3ea_moulderrpmstokes_standard?: string | null;
  cr3ea_moulderrpmstokes_temperature?: string | null;
  cr3ea_moulderrpmstokes_action?: string | null;
  cr3ea_sugarsaltcashewsprinkling_standard?: string | null;
  cr3ea_sugarsaltcashewsprinkling_temperature?: string | null;
  cr3ea_sugarsaltcashewsprinkling_action?: string | null;
  cr3ea_ingredientsofbatch_standard?: string | null;
  cr3ea_ingredientsofbatch_temperature?: string | null;
  cr3ea_ingredientsofbatch_action?: string | null;
  cr3ea_executivename: string;
  cr3ea_shift: string;
  cr3ea_tourstartdate: string;
  cr3ea_observedby: string | null;
  cr3ea_platform?: string;
  cr3ea_qualitytourid?: string;
}

// Interface for a single parameter value
export interface ParameterValue {
  standardValue: string;
  actualValue: string;
  actionTaken: string;
}

// Interface for process parameters
export interface ProcessParameters {
  rpoSolidFat: ParameterValue;
  invertSyrup: ParameterValue;
  butter: ParameterValue;
  blackjack: ParameterValue;
  water: ParameterValue;
  creamingTime: ParameterValue;
  mixingTime: ParameterValue;
  doughTemperature: ParameterValue;
  standingTime: ParameterValue;
  biscuitAppearance: ParameterValue;
  stackHeight: ParameterValue;
  dimensions: ParameterValue;
  moulderRpm: ParameterValue;
  sugarSaltCashewSprinkling: ParameterValue;
  ingredientsOfBatch: ParameterValue;
}

// Interface for start form data
export interface StartFormData {
  productName: string;
  executiveName: string;
}

// Interface for save response
export interface SaveResponse {
  success: boolean;
  message: string;
  data?: any;
}

// Interface for cycle data response
export interface CycleDataResponse {
  cycleNum: string;
  product: string;
  executiveName: string;
  cr3ea_rposolidfat_standard?: string | null;
  cr3ea_rposolidfat_temperature?: string | null;
  cr3ea_rposolidfat_action?: string | null;
  cr3ea_invertsyrup_standard?: string | null;
  cr3ea_invertsyrup_temperature?: string | null;
  cr3ea_invertsyrup_action?: string | null;
  cr3ea_butter_standard?: string | null;
  cr3ea_butter_temperature?: string | null;
  cr3ea_butter_action?: string | null;
  cr3ea_blackjack_standard?: string | null;
  cr3ea_blackjack_temperature?: string | null;
  cr3ea_blackjack_action?: string | null;
  cr3ea_water_standard?: string | null;
  cr3ea_water_temperature?: string | null;
  cr3ea_water_action?: string | null;
  cr3ea_creamingtime_standard?: string | null;
  cr3ea_creamingtime_temperature?: string | null;
  cr3ea_creamingtime_action?: string | null;
  cr3ea_mixingtime_standard?: string | null;
  cr3ea_mixingtime_temperature?: string | null;
  cr3ea_mixingtime_action?: string | null;
  cr3ea_doughtemperature_standard?: string | null;
  cr3ea_doughtemperature_temperature?: string | null;
  cr3ea_doughtemperature_action?: string | null;
  cr3ea_standingtime_standard?: string | null;
  cr3ea_standingtime_temperature?: string | null;
  cr3ea_standingtime_action?: string | null;
  cr3ea_biscuitappearance_standard?: string | null;
  cr3ea_biscuitappearance_temperature?: string | null;
  cr3ea_biscuitappearance_action?: string | null;
  cr3ea_stackheightspecifiednobiscuits_standard?: string | null;
  cr3ea_stackheightspecifiednobiscuits_temperature?: string | null;
  cr3ea_stackheightspecifiednobiscuits_action?: string | null;
  cr3ea_dimensionsatpackingtable_standard?: string | null;
  cr3ea_dimensionsatpackingtable_temperature?: string | null;
  cr3ea_dimensionsatpackingtable_action?: string | null;
  cr3ea_moisturecontent_standard?: string | null;
  cr3ea_moisturecontent_temperature?: string | null;
  cr3ea_moisturecontent_action?: string | null;
  cr3ea_drybiscuitweight_standard?: string | null;
  cr3ea_drybiscuitweight_temperature?: string | null;
  cr3ea_drybiscuitweight_action?: string | null;
  cr3ea_moulderrpmstokes_standard?: string | null;
  cr3ea_moulderrpmstokes_temperature?: string | null;
  cr3ea_moulderrpmstokes_action?: string | null;
  cr3ea_sugarsaltcashewsprinkling_standard?: string | null;
  cr3ea_sugarsaltcashewsprinkling_temperature?: string | null;
  cr3ea_sugarsaltcashewsprinkling_action?: string | null;
  cr3ea_ingredientsofbatch_standard?: string | null;
  cr3ea_ingredientsofbatch_temperature?: string | null;
  cr3ea_ingredientsofbatch_action?: string | null;
}

/**
 * Collect estimation data for cycle save
 * Converts component state to API format
 */
export async function collectEstimationDataCycleSave(
  cycleNum: number,
  startFormData: StartFormData,
  processParameters: ProcessParameters,
  qualityTourId: string,
  userName: string,
  selectedShift?: string | null
): Promise<{ savedData: ProcessParameterVerificationData[] }> {
  try {
    console.log('=== COLLECTING PROCESS PARAMETER VERIFICATION DATA FOR CYCLE SAVE ===');
    console.log('Cycle Number:', cycleNum);
    console.log('Start Form Data:', startFormData);
    console.log('Process Parameters:', processParameters);
    console.log('Quality Tour ID:', qualityTourId);
    console.log('User Name:', userName);

    const productName = startFormData.productName || "N/A";
    const executiveName = startFormData.executiveName || "N/A";

    const data: ProcessParameterVerificationData = {
      "cr3ea_productname": productName,
      "cr3ea_cycle": `Cycle-${cycleNum}`,
      "cr3ea_rposolidfat_standard": processParameters.rpoSolidFat.standardValue.trim() || null,
      "cr3ea_rposolidfat_temperature": processParameters.rpoSolidFat.actualValue.trim() || null,
      "cr3ea_rposolidfat_action": processParameters.rpoSolidFat.actionTaken.trim() || null,
      "cr3ea_invertsyrup_standard": processParameters.invertSyrup.standardValue.trim() || null,
      "cr3ea_invertsyrup_temperature": processParameters.invertSyrup.actualValue.trim() || null,
      "cr3ea_invertsyrup_action": processParameters.invertSyrup.actionTaken.trim() || null,
      "cr3ea_butter_standard": processParameters.butter.standardValue.trim() || null,
      "cr3ea_butter_temperature": processParameters.butter.actualValue.trim() || null,
      "cr3ea_butter_action": processParameters.butter.actionTaken.trim() || null,
      "cr3ea_blackjack_standard": processParameters.blackjack.standardValue.trim() || null,
      "cr3ea_blackjack_temperature": processParameters.blackjack.actualValue.trim() || null,
      "cr3ea_blackjack_action": processParameters.blackjack.actionTaken.trim() || null,
      "cr3ea_water_standard": processParameters.water.standardValue.trim() || null,
      "cr3ea_water_temperature": processParameters.water.actualValue.trim() || null,
      "cr3ea_water_action": processParameters.water.actionTaken.trim() || null,
      "cr3ea_creamingtime_standard": processParameters.creamingTime.standardValue.trim() || null,
      "cr3ea_creamingtime_temperature": processParameters.creamingTime.actualValue.trim() || null,
      "cr3ea_creamingtime_action": processParameters.creamingTime.actionTaken.trim() || null,
      "cr3ea_mixingtime_standard": processParameters.mixingTime.standardValue.trim() || null,
      "cr3ea_mixingtime_temperature": processParameters.mixingTime.actualValue.trim() || null,
      "cr3ea_mixingtime_action": processParameters.mixingTime.actionTaken.trim() || null,
      "cr3ea_doughtemperature_standard": processParameters.doughTemperature.standardValue.trim() || null,
      "cr3ea_doughtemperature_temperature": processParameters.doughTemperature.actualValue.trim() || null,
      "cr3ea_doughtemperature_action": processParameters.doughTemperature.actionTaken.trim() || null,
      "cr3ea_standingtime_standard": processParameters.standingTime.standardValue.trim() || null,
      "cr3ea_standingtime_temperature": processParameters.standingTime.actualValue.trim() || null,
      "cr3ea_standingtime_action": processParameters.standingTime.actionTaken.trim() || null,
      "cr3ea_biscuitappearance_standard": processParameters.biscuitAppearance.standardValue.trim() || null,
      "cr3ea_biscuitappearance_temperature": processParameters.biscuitAppearance.actualValue.trim() || null,
      "cr3ea_biscuitappearance_action": processParameters.biscuitAppearance.actionTaken.trim() || null,
      "cr3ea_stackheightspecifiednobiscuits_standard": processParameters.stackHeight.standardValue.trim() || null,
      "cr3ea_stackheightspecifiednobiscuits_temperature": processParameters.stackHeight.actualValue.trim() || null,
      "cr3ea_stackheightspecifiednobiscuits_action": processParameters.stackHeight.actionTaken.trim() || null,
      "cr3ea_dimensionsatpackingtable_standard": processParameters.dimensions.standardValue.trim() || null,
      "cr3ea_dimensionsatpackingtable_temperature": processParameters.dimensions.actualValue.trim() || null,
      "cr3ea_dimensionsatpackingtable_action": processParameters.dimensions.actionTaken.trim() || null,
      "cr3ea_moisturecontent_standard": null,
      "cr3ea_moisturecontent_temperature": null,
      "cr3ea_moisturecontent_action": null,
      "cr3ea_drybiscuitweight_standard": null,
      "cr3ea_drybiscuitweight_temperature": null,
      "cr3ea_drybiscuitweight_action": null,
      "cr3ea_moulderrpmstokes_standard": processParameters.moulderRpm.standardValue.trim() || null,
      "cr3ea_moulderrpmstokes_temperature": processParameters.moulderRpm.actualValue.trim() || null,
      "cr3ea_moulderrpmstokes_action": processParameters.moulderRpm.actionTaken.trim() || null,
      "cr3ea_sugarsaltcashewsprinkling_standard": processParameters.sugarSaltCashewSprinkling.standardValue.trim() || null,
      "cr3ea_sugarsaltcashewsprinkling_temperature": processParameters.sugarSaltCashewSprinkling.actualValue.trim() || null,
      "cr3ea_sugarsaltcashewsprinkling_action": processParameters.sugarSaltCashewSprinkling.actionTaken.trim() || null,
      "cr3ea_ingredientsofbatch_standard": processParameters.ingredientsOfBatch.standardValue.trim() || null,
      "cr3ea_ingredientsofbatch_temperature": processParameters.ingredientsOfBatch.actualValue.trim() || null,
      "cr3ea_ingredientsofbatch_action": processParameters.ingredientsOfBatch.actionTaken.trim() || null,
      "cr3ea_executivename": executiveName,
      "cr3ea_shift": selectedShift || sessionStorage.getItem("shiftValue") || "shift 1",
      "cr3ea_tourstartdate": moment().format('DD/MM/YYYY'),
      "cr3ea_observedby": userName || null,
      "cr3ea_platform": "PWA",
      "cr3ea_qualitytourid": qualityTourId
    };

    console.log('Collected Estimation Data:', data);

    return { savedData: [data] };
  } catch (error) {
    console.error('Error collecting estimation data:', error);
    throw error;
  }
}

/**
 * Save section API call
 */
export async function saveSectionApiCall(data: ProcessParameterVerificationData[]): Promise<SaveResponse> {
  try {
    console.log('=== SAVING PROCESS PARAMETER VERIFICATION DATA ===');
    console.log('Data to save:', data);

    const tokenResult = await getAccessToken();
    const accessToken = tokenResult?.token;
    if (!accessToken) {
      throw new Error("Access token is invalid or missing");
    }

    const headers = {
      "Accept": "application/json",
      "Content-Type": "application/json; charset=utf-8",
      "OData-MaxVersion": "4.0",
      "OData-Version": "4.0",
      "Prefer": "return=representation",
      "Authorization": `Bearer ${accessToken}`
    };

    const apiVersion = "9.2";
    const tableName = "cr3ea_prod_mixingparameters";
    const apiUrl = `${environmentUrl}/api/data/v${apiVersion}/${tableName}`;

    const results = [];
    for (const record of data) {
      console.log('Saving record:', record);

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(record)
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Failed to save record:', response.status, errorText);
        throw new Error(`Failed to save record: ${response.status} - ${errorText}`);
      }

      const result = await response.json();
      console.log('Record saved successfully:', result);
      results.push(result);
    }

    console.log(`${data.length} records saved successfully`);
    return {
      success: true,
      message: `${data.length} records saved successfully`,
      data: results
    };
  } catch (error) {
    console.error('Error saving process parameter verification records:', error);
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Failed to save records. Please try again.',
      data: []
    };
  }
}

/**
 * Fetch cycle data for Process Parameter Verification
 * Fetches all completed cycles for a given quality tour ID
 */
export async function fetchCycleData(qualityTourId: string): Promise<CycleDataResponse[]> {
  try {
    console.log('=== FETCHING PROCESS PARAMETER VERIFICATION CYCLE DATA ===');
    console.log('Quality Tour ID:', qualityTourId);

    const tokenResult = await getAccessToken();
    const accessToken = tokenResult?.token;
    if (!accessToken) {
      throw new Error("Access token is invalid or missing");
    }

    const headers = {
      "Accept": "application/json",
      "OData-MaxVersion": "4.0",
      "OData-Version": "4.0",
      "Authorization": `Bearer ${accessToken}`
    };

    const apiVersion = "9.2";
    const tableName = "cr3ea_prod_mixingparameters";
    const selectFields = [
      'cr3ea_productname',
      'cr3ea_cycle',
      'cr3ea_rposolidfat_standard',
      'cr3ea_rposolidfat_temperature',
      'cr3ea_rposolidfat_action',
      'cr3ea_invertsyrup_standard',
      'cr3ea_invertsyrup_temperature',
      'cr3ea_invertsyrup_action',
      'cr3ea_butter_standard',
      'cr3ea_butter_temperature',
      'cr3ea_butter_action',
      'cr3ea_blackjack_standard',
      'cr3ea_blackjack_temperature',
      'cr3ea_blackjack_action',
      'cr3ea_water_standard',
      'cr3ea_water_temperature',
      'cr3ea_water_action',
      'cr3ea_creamingtime_standard',
      'cr3ea_creamingtime_temperature',
      'cr3ea_creamingtime_action',
      'cr3ea_mixingtime_standard',
      'cr3ea_mixingtime_temperature',
      'cr3ea_mixingtime_action',
      'cr3ea_doughtemperature_standard',
      'cr3ea_doughtemperature_temperature',
      'cr3ea_doughtemperature_action',
      'cr3ea_standingtime_standard',
      'cr3ea_standingtime_temperature',
      'cr3ea_standingtime_action',
      'cr3ea_biscuitappearance_standard',
      'cr3ea_biscuitappearance_temperature',
      'cr3ea_biscuitappearance_action',
      'cr3ea_stackheightspecifiednobiscuits_standard',
      'cr3ea_stackheightspecifiednobiscuits_temperature',
      'cr3ea_stackheightspecifiednobiscuits_action',
      'cr3ea_dimensionsatpackingtable_standard',
      'cr3ea_dimensionsatpackingtable_temperature',
      'cr3ea_dimensionsatpackingtable_action',
      'cr3ea_moisturecontent_standard',
      'cr3ea_moisturecontent_temperature',
      'cr3ea_moisturecontent_action',
      'cr3ea_drybiscuitweight_standard',
      'cr3ea_drybiscuitweight_temperature',
      'cr3ea_drybiscuitweight_action',
      'cr3ea_moulderrpmstokes_standard',
      'cr3ea_moulderrpmstokes_temperature',
      'cr3ea_moulderrpmstokes_action',
      'cr3ea_sugarsaltcashewsprinkling_standard',
      'cr3ea_sugarsaltcashewsprinkling_temperature',
      'cr3ea_sugarsaltcashewsprinkling_action',
      'cr3ea_ingredientsofbatch_standard',
      'cr3ea_ingredientsofbatch_temperature',
      'cr3ea_ingredientsofbatch_action',
      'cr3ea_executivename',
      'cr3ea_shift',
      'cr3ea_tourstartdate',
      'cr3ea_observedby',
      'cr3ea_platform'
    ].join(',');

    // Build the filter URL - use same format as other working services
    const apiUrl = `${environmentUrl}/api/data/v${apiVersion}/${tableName}?$filter=cr3ea_qualitytourid eq '${qualityTourId}'&$select=${selectFields}`;
    
    console.log('=== FETCH CYCLE DATA DEBUG ===');
    console.log('Quality Tour ID:', qualityTourId);
    console.log('Table Name:', tableName);
    console.log('Full URL:', apiUrl);
    console.log('Select Fields Count:', selectFields.split(',').length);

    const response = await fetch(apiUrl, { headers });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('=== FETCH ERROR DETAILS ===');
      console.error('Status:', response.status);
      console.error('Status Text:', response.statusText);
      console.error('Error Response:', errorText);
      console.error('Request URL:', apiUrl);
      console.error('Headers:', headers);
      
      // Try to parse error for more details
      try {
        const errorJson = JSON.parse(errorText);
        console.error('Parsed Error:', errorJson);
      } catch (e) {
        console.error('Error response is not JSON');
      }
      
      throw new Error(`Failed to fetch data: ${response.status} ${response.statusText} - ${errorText}`);
    }

    const data = await response.json();
    console.log('API Response:', data);
    console.log('Number of records:', data.value?.length || 0);

    if (!data.value || !Array.isArray(data.value)) {
      console.warn('Invalid response format, data.value is not an array');
      return [];
    }

    const result: CycleDataResponse[] = [];

    data.value.forEach((record: any) => {
      const cycleNum = (record.cr3ea_cycle || '').replace('Cycle-', '');
      
      if (!cycleNum) {
        console.warn('Skipping record with invalid cycle:', record.cr3ea_cycle);
        return;
      }

      result.push({
        cycleNum,
        product: record.cr3ea_productname || "N/A",
        executiveName: record.cr3ea_executivename || "N/A",
        cr3ea_rposolidfat_standard: record.cr3ea_rposolidfat_standard || null,
        cr3ea_rposolidfat_temperature: record.cr3ea_rposolidfat_temperature || null,
        cr3ea_rposolidfat_action: record.cr3ea_rposolidfat_action || null,
        cr3ea_invertsyrup_standard: record.cr3ea_invertsyrup_standard || null,
        cr3ea_invertsyrup_temperature: record.cr3ea_invertsyrup_temperature || null,
        cr3ea_invertsyrup_action: record.cr3ea_invertsyrup_action || null,
        cr3ea_butter_standard: record.cr3ea_butter_standard || null,
        cr3ea_butter_temperature: record.cr3ea_butter_temperature || null,
        cr3ea_butter_action: record.cr3ea_butter_action || null,
        cr3ea_blackjack_standard: record.cr3ea_blackjack_standard || null,
        cr3ea_blackjack_temperature: record.cr3ea_blackjack_temperature || null,
        cr3ea_blackjack_action: record.cr3ea_blackjack_action || null,
        cr3ea_water_standard: record.cr3ea_water_standard || null,
        cr3ea_water_temperature: record.cr3ea_water_temperature || null,
        cr3ea_water_action: record.cr3ea_water_action || null,
        cr3ea_creamingtime_standard: record.cr3ea_creamingtime_standard || null,
        cr3ea_creamingtime_temperature: record.cr3ea_creamingtime_temperature || null,
        cr3ea_creamingtime_action: record.cr3ea_creamingtime_action || null,
        cr3ea_mixingtime_standard: record.cr3ea_mixingtime_standard || null,
        cr3ea_mixingtime_temperature: record.cr3ea_mixingtime_temperature || null,
        cr3ea_mixingtime_action: record.cr3ea_mixingtime_action || null,
        cr3ea_doughtemperature_standard: record.cr3ea_doughtemperature_standard || null,
        cr3ea_doughtemperature_temperature: record.cr3ea_doughtemperature_temperature || null,
        cr3ea_doughtemperature_action: record.cr3ea_doughtemperature_action || null,
        cr3ea_standingtime_standard: record.cr3ea_standingtime_standard || null,
        cr3ea_standingtime_temperature: record.cr3ea_standingtime_temperature || null,
        cr3ea_standingtime_action: record.cr3ea_standingtime_action || null,
        cr3ea_biscuitappearance_standard: record.cr3ea_biscuitappearance_standard || null,
        cr3ea_biscuitappearance_temperature: record.cr3ea_biscuitappearance_temperature || null,
        cr3ea_biscuitappearance_action: record.cr3ea_biscuitappearance_action || null,
        cr3ea_stackheightspecifiednobiscuits_standard: record.cr3ea_stackheightspecifiednobiscuits_standard || null,
        cr3ea_stackheightspecifiednobiscuits_temperature: record.cr3ea_stackheightspecifiednobiscuits_temperature || null,
        cr3ea_stackheightspecifiednobiscuits_action: record.cr3ea_stackheightspecifiednobiscuits_action || null,
        cr3ea_dimensionsatpackingtable_standard: record.cr3ea_dimensionsatpackingtable_standard || null,
        cr3ea_dimensionsatpackingtable_temperature: record.cr3ea_dimensionsatpackingtable_temperature || null,
        cr3ea_dimensionsatpackingtable_action: record.cr3ea_dimensionsatpackingtable_action || null,
        cr3ea_moisturecontent_standard: record.cr3ea_moisturecontent_standard || null,
        cr3ea_moisturecontent_temperature: record.cr3ea_moisturecontent_temperature || null,
        cr3ea_moisturecontent_action: record.cr3ea_moisturecontent_action || null,
        cr3ea_drybiscuitweight_standard: record.cr3ea_drybiscuitweight_standard || null,
        cr3ea_drybiscuitweight_temperature: record.cr3ea_drybiscuitweight_temperature || null,
        cr3ea_drybiscuitweight_action: record.cr3ea_drybiscuitweight_action || null,
        cr3ea_moulderrpmstokes_standard: record.cr3ea_moulderrpmstokes_standard || null,
        cr3ea_moulderrpmstokes_temperature: record.cr3ea_moulderrpmstokes_temperature || null,
        cr3ea_moulderrpmstokes_action: record.cr3ea_moulderrpmstokes_action || null,
        cr3ea_sugarsaltcashewsprinkling_standard: record.cr3ea_sugarsaltcashewsprinkling_standard || null,
        cr3ea_sugarsaltcashewsprinkling_temperature: record.cr3ea_sugarsaltcashewsprinkling_temperature || null,
        cr3ea_sugarsaltcashewsprinkling_action: record.cr3ea_sugarsaltcashewsprinkling_action || null,
        cr3ea_ingredientsofbatch_standard: record.cr3ea_ingredientsofbatch_standard || null,
        cr3ea_ingredientsofbatch_temperature: record.cr3ea_ingredientsofbatch_temperature || null,
        cr3ea_ingredientsofbatch_action: record.cr3ea_ingredientsofbatch_action || null
      });
    });

    console.log(`Processed ${result.length} records (multiple products per cycle supported)`);
    return result;
  } catch (error) {
    console.error('Error fetching cycle data:', error);
    if (error instanceof Error) {
      console.error('Error message:', error.message);
      console.error('Error stack:', error.stack);
    }
    return [];
  }
}

/**
 * Interface for offline submission
 */
export interface ProcessParameterVerificationOfflineSubmission {
  cycleNo: number;
  records: ProcessParameterVerificationData[];
  timestamp: number;
  plantTourId?: string;
}

/**
 * Interface for sync response
 */
export interface SyncOfflineDataResponse {
  success: boolean;
  message: string;
  syncedCount?: number;
  errorCount?: number;
}

/**
 * Function to sync offline data to backend
 */
export async function syncOfflineDataToBackend(
  offlineSubmissions: ProcessParameterVerificationOfflineSubmission[],
  qualityTourId: string,
  userName: string,
  selectedShift?: string | null
): Promise<SyncOfflineDataResponse> {
  try {
    console.log('=== SYNCING PROCESS PARAMETER VERIFICATION OFFLINE DATA TO BACKEND ===');
    console.log('Offline submissions to sync:', offlineSubmissions);
    console.log('Offline submissions length:', offlineSubmissions.length);
    console.log('Quality Tour ID:', qualityTourId);
    console.log('User Name:', userName);
    console.log('Selected Shift:', selectedShift);

    if (!offlineSubmissions || offlineSubmissions.length === 0) {
      console.log('No offline data to sync');
      return {
        success: true,
        message: 'No offline data to sync',
        syncedCount: 0,
        errorCount: 0
      };
    }

    const tokenResult = await getAccessToken();
    const accessToken = tokenResult?.token;
    if (!accessToken) {
      throw new Error("Access token is invalid or missing");
    }

    let totalSynced = 0;
    let totalErrors = 0;
    const errors: string[] = [];

    for (const submission of offlineSubmissions) {
      try {
        const cycleNo = submission.cycleNo;
        const records = submission.records || [];

        console.log(`Processing offline data for cycle ${cycleNo}:`, records);

        // Ensure shift, platform, and qualityTourId are set correctly
        const recordsToSave = records.map((record: any) => ({
          ...record,
          cr3ea_shift: selectedShift || record.cr3ea_shift || sessionStorage.getItem("shiftValue") || "shift 1",
          cr3ea_platform: "PWA",
          cr3ea_qualitytourid: qualityTourId || submission.plantTourId || record.cr3ea_qualitytourid
        }));

        // Save records to API
        const saveResult = await saveSectionApiCall(recordsToSave);

        if (saveResult.success) {
          console.log(`Successfully synced cycle ${cycleNo}`);
          totalSynced += recordsToSave.length;
        } else {
          throw new Error(`Failed to save cycle ${cycleNo}: ${saveResult.message}`);
        }
      } catch (error) {
        console.error(`Failed to sync cycle ${submission.cycleNo}:`, error);
        errors.push(`Cycle ${submission.cycleNo}: ${error instanceof Error ? error.message : 'Unknown error'}`);
        totalErrors++;
      }
    }

    const message = `Synced ${totalSynced} record(s) successfully${totalErrors > 0 ? `, ${totalErrors} error(s)` : ''}`;
    console.log('Sync completed:', message);

    return {
      success: totalErrors === 0,
      message,
      syncedCount: totalSynced,
      errorCount: totalErrors
    };
  } catch (error) {
    console.error('Error syncing offline data:', error);
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Failed to sync offline data',
      syncedCount: 0,
      errorCount: offlineSubmissions.length
    };
  }
}

